/**
 * @desc 配置
 * @file config.js
 * @author dingzhenyue@baidu.com
 */

// 擅长领域数据
export const expertArea = [
    {
        label: '婚姻家庭',
        value: '婚姻家庭'
    }, {
        label: '经济纠纷',
        value: '经济纠纷'
    }, {
        label: '劳动纠纷',
        value: '劳动纠纷'
    }, {
        label: '交通事故',
        value: '交通事故'
    }, {
        label: '刑事辩护',
        value: '刑事辩护'
    },
    {
        label: '涉外纠纷',
        value: '涉外纠纷'
    },
    {
        label: '合同纠纷',
        value: '合同纠纷'
    }, {
        label: '拆迁安置',
        value: '拆迁安置'
    },
    {
        label: '房产纠纷',
        value: '房产纠纷'
    },
    {
        label: '知识产权',
        value: '知识产权'
    },
    {
        label: '行政纠纷',
        value: '行政纠纷'
    },
    {
        label: '公司事务',
        value: '公司事务'
    },
    {
        label: '医疗纠纷',
        value: '医疗纠纷'
    }
];

 // 星期选择组件数据
export const weeks = [
    {
        label: '周一',
        value: '1'
    },
    {
        label: '周二',
        value: '2'
    },
    {
        label: '周三',
        value: '3'
    },
    {
        label: '周四',
        value: '4'
    },
    {
        label: '周五',
        value: '5'
    },
    {
        label: '周六',
        value: '6'
    },
    {
        label: '周日',
        value: '7'
    }
];
